import { supabase } from "@/shared/lib/supabase";

export type AddressLinkPurpose = "domicile" | "mailing" | "situs" | "place_of_death";

export interface AddressLinkEntity {
  estate_id?: number;
  contact_id?: number;
  estate_item_id?: number;
  user_id?: number;
}

interface ResolveAddressLinkArgs {
  purpose?: AddressLinkPurpose;
  entity: AddressLinkEntity;
  raw?: string;
  addressId?: number;
}

export interface ResolveAddressLinkResult {
  addressId: number | null;
  status: string | null;
  duplicateSitus?: boolean;
}

export async function resolveAddressLink({
  raw,
  addressId,
  purpose,
  entity,
}: ResolveAddressLinkArgs): Promise<ResolveAddressLinkResult | null> {
  const body =
    addressId != null
      ? { addressId, purpose, entity }
      : { raw: (raw ?? "").trim(), purpose, entity };

  try {
    const { data, error } = await supabase.functions.invoke("account/resolve-address", {
      body,
    });

    if (error) {
      console.warn("resolveAddressLink failed:", error);
      return null;
    }

    return data as ResolveAddressLinkResult;
  } catch (err) {
    console.warn("resolveAddressLink failed:", err);
    return null;
  }
}
